module.exports = __webpack_public_path__ + "static/media/romulo.d141ab0d.png";